import { render, staticRenderFns } from "./avisoLegal-web.html?vue&type=template&id=e4330aba&"
import script from "./avisoLegal-web.ts?vue&type=script&lang=ts&"
export * from "./avisoLegal-web.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports